module.exports = __webpack_public_path__ + "img/tema-1-9.7aa88ff8.png";